module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/ic-medium-8fd0c556624235f35da348d7fc8ec60a.png";